import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ChipInput from 'material-ui-chip-input';

import AdminAPI from '../../../../api/AdminApi';

const LookupContainer = styled.div`
  margin-left: auto;
  margin-right: 0px;
  float: left;
  margin-right: 50px;
`;

const restrictionTypes = [
  { typeId: 1, typeName: 'Cost Centre' },
  { typeId: 2, typeName: 'Division' },
  { typeId: 3, typeName: 'State' },
  { typeId: 4, typeName: 'Classification' },
  { typeId: 5, typeName: 'Lease Type' },
];

class RestrictionSummary extends Component {
  static propTypes = {
    companyCode: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    businessEntityId: PropTypes.number.isRequired,
    typeId: PropTypes.number.isRequired,
    Restrictions: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      allAvailableOptions: [],
    };
    this.getRestriction = this.getRestriction.bind(this);
  }

  componentWillMount() {
    const { businessEntityId, countryCode, companyCode } = this.props;
    if (countryCode && companyCode && businessEntityId > 0) {
      this.getRestriction(businessEntityId, countryCode, companyCode);
    }
  }

  componentWillReceiveProps(newProps) {
    const { businessEntityId, countryCode, companyCode } = newProps;
    if (countryCode && companyCode && businessEntityId > 0) {
      this.getRestriction(businessEntityId, countryCode, companyCode);
    }
  }

  getRestriction(businessEntityId, countryCode, companyCode) {
    AdminAPI.getRestriction(businessEntityId, countryCode, companyCode)
      .then(data => {
        this.setState({
          allAvailableOptions: data,
        });
      })
      .catch(error => {
        throw error;
      });
  }

  render() {
    const divRestrictionSummary = restrictionTypes.map((e, idx) => {
      let restrictionFiltered = [];
      restrictionFiltered = this.props.Restrictions.filter(restrict => {
        if (restrict.typeId === e.typeId) {
          return true;
        }
        return false;
      });

      let options = [];
      if (this.state.allAvailableOptions) {
        options = this.state.allAvailableOptions.filter(option => {
          if (option.typeId === e.typeId) {
            return true;
          }
          return false;
        });
      }

      if (
        options &&
        options.length > 0 &&
        restrictionFiltered &&
        restrictionFiltered.length > 0
      ) {
        return (
          <LookupContainer key={`res_lookup_container${idx}`}>
            <ChipInput
              defaultValue={
                restrictionFiltered[0].values === undefined
                  ? []
                  : restrictionFiltered[0].values
              }
              placeholder={e.typeName}
              dataSource={options[0].options}
              dataSourceConfig={{ text: 'label', value: 'value' }}
              fullWidthInput
              menuStyle={{ height: '320px' }}
              popoverProps={{ canAutoPosition: true }}
              openOnFocus
              onChange={values =>
                this.props.onChangeRestriction(
                  e.typeId,
                  values,
                  this.props.companyCode,
                  this.props.countryCode,
                  this.props.Restrictions
                )
              }
            />
          </LookupContainer>
        );
      }
    }, this);

    return <div>{divRestrictionSummary}</div>;
  }
}

export default RestrictionSummary;



// WEBPACK FOOTER //
// ./src/features/admin/components/restrictions/RestrictionSummary.js